import { RouteProps } from "react-router-dom";

import { connect } from 'react-redux';
import { Route, Redirect } from 'react-router-dom'; 
import { RootState } from "store";
import {  AppointmentPath } from "config/constants";
import { DoctorLogin } from "config/routersConstants";

interface IOwnProps extends RouteProps {
    hasAnyAuthorities?: string[];
  }
  
  export interface IPrivateRouteProps extends IOwnProps, StateProps {}
  
  export const PublicRouteComponent = ({ 
    isAuthenticated, 
    account,
    ...rest
  }: IPrivateRouteProps) => {
    /*Back button issue fix - Feb11-2022 */
    const isMultiple = Array.isArray(rest.path)
    const path: any = rest.path;
    const isDoctorLogin = isMultiple ? path.map((item)=>item === DoctorLogin.path) : rest.path === DoctorLogin.path 

    if(isAuthenticated  &&    isDoctorLogin){


        return <Redirect
                  to={{
                    pathname: AppointmentPath,
                    search: rest.location.search,
                    state: { from: rest.location },
                  }}
                />

      
    }
    /*Back button issue fix - end */
    return  <Route {...rest} />;
  }

  
const mapStateToProps = (
    { authentication: { isAuthenticated, account, sessionHasBeenFetched } }: RootState,
    { hasAnyAuthorities = [] }: IOwnProps
  ) => ({
    isAuthenticated , account
  });
  
  type StateProps = ReturnType<typeof mapStateToProps>;
  
  /**
   * A route wrapped in an authentication check so that routing happens only when you are authenticated.
   * Accepts same props as React router Route.
   * The route also checks for authorization if hasAnyAuthorities is specified.
   */
  export const PublicRoute = connect(mapStateToProps, null, null, { pure: false })(PublicRouteComponent);
  
  export default PublicRoute;
  